/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const HelpChat = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12V20.5C2 21.3284 2.67157 22 3.5 22H12ZM20.5 12C20.5 16.6944 16.6944 20.5 12 20.5H3.5V12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z"
                        fill={color}
                    />
                    <path
                        d="M12.5417 16.1667C12.5417 16.6269 12.1686 17 11.7083 17C11.2481 17 10.875 16.6269 10.875 16.1667C10.875 15.7064 11.2481 15.3333 11.7083 15.3333C12.1686 15.3333 12.5417 15.7064 12.5417 16.1667Z"
                        fill={color}
                    />
                    <path
                        d="M13.5839 7.73966C12.7646 6.92032 11.4928 6.76376 10.4992 7.35991L10.3578 7.44476C9.79766 7.78083 9.37624 8.30618 9.16968 8.92586L9 9.43489L10.1859 9.83018L10.3555 9.32115C10.4677 8.98454 10.6966 8.69917 11.0009 8.51662L11.1423 8.43177C11.6441 8.13073 12.2863 8.20979 12.7 8.62354C13.2253 9.14877 13.1922 10.01 12.6282 10.4934L11.9022 11.1157C11.3621 11.5786 11.0513 12.2545 11.0513 12.9659V14.0833H12.3013V12.9659C12.3013 12.6194 12.4527 12.2902 12.7157 12.0647L13.4417 11.4425C14.5585 10.4852 14.624 8.77976 13.5839 7.73966Z"
                        fill={color}
                    />
                </svg>
        );
    };
